import Vue from 'vue'
import Router from 'vue-router'
import homeRouter from './home.router'
import preservationRouter from './preservation.router'
import guaranteeRouter from './guarantee.router'
import loginRouter from './login.router'
import reconsiderRouter from './reconsider.router'

Vue.use(Router)
const router = new Router({
    // mode: 'history',
    routes: [
        // {
        //   path: '*',
        //   component: () => import('../views/login/index'),
        //   meta: {
        //     keepAlive: false,
        //     title: '登录'
        //   }
        // },
        {
            path: '*',
            component: () => import('../views/home/index'),
            redirect: '/home/index',
            meta: {
                title: '在线服务保全'
            }
        },
        ...homeRouter,
        ...preservationRouter,
        ...guaranteeRouter,
        ...loginRouter,
        ...reconsiderRouter
    ],
})
//使用Vue.mixin的方法拦截了路由离开事件，并在该拦截方法中实现了销毁页面缓存的功能。

export default router
